
// UAT / Local
const AdalConfig = {
    tenant: '043207df-e689-4bf6-9020-01038f11f0b1',
    clientId: 'f9be49cb-4249-4cf8-801e-30f9e594fcd6',
    redirectUri: window.location.origin,
    endpoints: {
      api: 'f9be49cb-4249-4cf8-801e-30f9e594fcd6',
    },
    cacheLocation: 'localStorage',
    postLogoutRedirectUri: window.location.origin + '/signedout',
  };

  export default AdalConfig;